import SelectAgeBar from './SelectAgeBar';
import { connect } from 'react-redux';
import {
  monthlyStatementActions,
  contentSel
} from 'src/store/modules/monthlyStatement';
import { withI18n } from 'react-i18next';

const mapStateToProps = (state: any) => {
  return {
    monthlyStatementContent: contentSel(state)
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  getMonthlyStatement: (page: number, period: number, size: number) => {
    dispatch(monthlyStatementActions.getMonthlyStatement(page, period, size));
  }
});

export const pureComponent = SelectAgeBar;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(SelectAgeBar));
